import { useContext } from 'react';
import { AutoMetricContext } from "../context";
export var useAutoMetricContext = function useAutoMetricContext() {
  var context = useContext(AutoMetricContext);
  if (!context) {
    throw new Error('Попытка получения AutoMetricContext за пределами AutoMetricRoot');
  }
  return context;
};